import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import MapTooltipItem from './map-tooltip-item';

const MapTooltip = ({ latLngGroups, activeResult }) => {
  if (latLngGroups && activeResult) {
    const { latitude, longitude } = activeResult;
    const activeResultKey = `${latitude},${longitude}`;
    let activeResultLatLngGroup = latLngGroups[activeResultKey];
    if (activeResultLatLngGroup) {
      if (activeResultLatLngGroup.length > 1) {
        return (
          <Carousel interval={null} indicators={true} controls={false}>
            {activeResultLatLngGroup.map((item, idx) => {
              return (
                <Carousel.Item key={idx}>
                  <MapTooltipItem item={item} />
                </Carousel.Item>
              );
            })}
          </Carousel>
        );
      } else {
        const item = activeResultLatLngGroup[0];
        return <MapTooltipItem item={item} />;
      }
    }  
  }
  return null;
};

export default MapTooltip;
